// Imports => React
import { useEffect, useMemo } from 'react';

import clsx from 'clsx';

// Imports => Atoms
import {withTranslation} from "react-i18next";
import {AcEmptyBlock} from "ui-kit";
import {withStore} from "../../stores";
import {observer} from "mobx-react-lite";

const _CLASSES = {
  MAIN: 'ac-navigation-wrp ac-navigation-wrp--visible h-margin-top-60 d-none d-md-block',
  NAVIGATION: {
    MAIN: 'ac-navigation',
  },
};

const AcNavigationError = (({ store: { api }, error, t}) => {
  useEffect(() => {
    error.component = 'ac-navigation-error.web.js'
    error.location = window.location.href;
    api.reporting.report(error);
  }, [error]);

  const getMainClassNames = useMemo(
    () => {
      return clsx(
        _CLASSES.MAIN,
      );
    }, []);

  const getNavigationClassNames = useMemo(() => {
    return clsx(_CLASSES.NAVIGATION.MAIN);
  });

  return (
    <div className={getMainClassNames} role={'navigation'}>
      <nav className={getNavigationClassNames}>
        <AcEmptyBlock message={t('something-went-wrong', {ns: 'common'})} />
      </nav>
    </div>
  );
}
);

export default withTranslation(['common'])(withStore(observer(AcNavigationError)));
